// src/services/leadsService.js
import api from './api';

export const uploadLeads = (formData) => {
    return api.post('/leads/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const getLeads = () => {
    return api.get('/leads');
};

export const deleteLead = (id) => {
    return api.delete(`/leads/${id}`);
};
